var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ModuleValueGeneral, SchemaModuleGeneral } from './module-general';
import * as rawJSONSchemaModuleBariatric from '../../schemas/module-bariatric.json';
var LBS_PER_KG = 2.20462;
var CM_PER_IN = 2.54;
var ModuleValueBariatric = (function (_super) {
    __extends(ModuleValueBariatric, _super);
    function ModuleValueBariatric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ModuleValueBariatric;
}(ModuleValueGeneral));
var SchemaModuleBariatric = (function (_super) {
    __extends(SchemaModuleBariatric, _super);
    function SchemaModuleBariatric() {
        var _this = _super.call(this) || this;
        _this._converting = {};
        _this._conversionTimeout = {};
        _this.loadSchema(rawJSONSchemaModuleBariatric);
        return _this;
    }
    SchemaModuleBariatric.prototype.hook = function (form) {
        var _this = this;
        _super.prototype.hook.call(this, form);
        this.listenValue(['target_bmi'], this.calculateBodyWeightOnTargetBmi.bind(this));
        this.listenValue(['bmi', 'target_bmi'], this.fieldHandlerBmiTargetBmi.bind(this));
        this.listenValue(['target_body_weight', 'body_height'], this.fieldHandlerTargetBodyWeightBodyHeight.bind(this));
        this.listenValue(['body_weight', 'target_body_weight'], this.fieldHandlerBodyWeightTargetBodyWeight.bind(this));
        this.listenValue(['waist_circumference', 'hip_circumference'], this.calculateWaistHipRatio.bind(this));
        // The calculations above all run on the metric fields (kg/cm), which are hidden in
        // imperial mode. Keep each metric/imperial pair in sync — the canonical metric value
        // drives the calculations, the imperial value is for entry/display in imperial mode.
        // Imperial to Metric (active only in imperial mode, when the imperial field is shown)
        this.listenValue('target_body_weight_imperial', function (v) { return _this.convertUnit(v, 'target_body_weight', 'target_weight', 1 / LBS_PER_KG, false); });
        this.listenValue('waist_circumference_imperial', function (v) { return _this.convertUnit(v, 'waist_circumference', 'waist', CM_PER_IN, false); });
        this.listenValue('hip_circumference_imperial', function (v) { return _this.convertUnit(v, 'hip_circumference', 'hip', CM_PER_IN, false); });
        // Metric to Imperial (active only in metric mode, when the metric field is shown)
        this.listenValue('target_body_weight', function (v) { return _this.convertUnit(v, 'target_body_weight_imperial', 'target_weight', LBS_PER_KG, true); });
        this.listenValue('waist_circumference', function (v) { return _this.convertUnit(v, 'waist_circumference_imperial', 'waist', 1 / CM_PER_IN, true); });
        this.listenValue('hip_circumference', function (v) { return _this.convertUnit(v, 'hip_circumference_imperial', 'hip', 1 / CM_PER_IN, true); });
        // Excess Weight is always computed in kg; mirror it into the imperial (lbs) display field.
        this.listenValue('excess_weight', this.fieldHandlerExcessWeightImperial.bind(this));
    };
    SchemaModuleBariatric.prototype.fieldHandlerTargetBodyWeightBodyHeight = function () {
        // Read via getValue, not the listenValue args: in imperial mode body_height (and
        // target_body_weight) are hidden, so the visibility-checked args arrive undefined
        // and would wipe Target BMI. The canonical kg/cm values are always populated (kept
        // in sync from the imperial fields), so Target BMI is computed in both unit modes.
        var target_body_weight_kg = this.getValue('target_body_weight');
        var height_cm = this.getValue('body_height');
        if (target_body_weight_kg && height_cm) {
            this.calculateTargetBMI(target_body_weight_kg, height_cm);
        }
    };
    SchemaModuleBariatric.prototype.calculateTargetBMI = function (target_body_weight_kg, height_cm) {
        var targetBmi = null;
        var height_m = height_cm / 100;
        var targetBmiSchema = this.getProperty('target_bmi').schema;
        // Clear previous message
        targetBmiSchema.description = '';
        if (target_body_weight_kg === null && height_cm === null) {
            // No values
        }
        else if (target_body_weight_kg === null || height_cm === null) {
            // Show info message about partial completion
            targetBmiSchema.description = this.generateMessage('%0 calculation requires both %1 and %2', 'target_bmi', 'target_body_weight', 'body_height');
        }
        else if (target_body_weight_kg > 0 && height_m > 0) {
            // Calculate the BMI
            targetBmi = Math.round(target_body_weight_kg / (Math.pow(height_m, 2)));
            if (isNaN(targetBmi) || !isFinite(targetBmi)) {
                targetBmi = null;
            }
            // Show out-of-range messages
            if (targetBmi < 18.5) {
                targetBmiSchema.description = 'Low';
            }
            else if (targetBmi > 30) {
                targetBmiSchema.description = 'Very high';
            }
            else if (targetBmi > 25) {
                targetBmiSchema.description = 'High';
            }
        }
        this.updateValue('target_bmi', targetBmi);
    };
    SchemaModuleBariatric.prototype.fieldHandlerBodyWeightTargetBodyWeight = function () {
        // body_weight is always stored in kg — in imperial mode the field is hidden
        // but kept in sync from body_weight_imperial by fieldHandlerImperialWeightToMetric
        // (module-general). Read it via getValue, not the visibility-checked listenValue
        // args (which arrive undefined while the metric field is hidden), so Excess
        // Weight is correctly computed from the kg value in both metric and imperial modes.
        var body_weight_kg = this.getValue('body_weight');
        var target_body_weight_kg = this.getValue('target_body_weight');
        if (body_weight_kg && target_body_weight_kg) {
            this.updateValue('excess_weight', body_weight_kg - target_body_weight_kg);
        }
        else {
            this.updateValue('excess_weight', null);
        }
    };
    SchemaModuleBariatric.prototype.fieldHandlerBmiTargetBmi = function () {
        var bmi = this.getValue('bmi');
        var target_bmi = this.getValue('target_bmi');
        if (bmi && target_bmi) {
            this.updateValue('excess_bmi', bmi - target_bmi);
        }
        else {
            this.updateValue('excess_bmi', null);
        }
    };
    /**
     * Calculate the target body weight based on the target BMI
     * @param target_bmi
     */
    SchemaModuleBariatric.prototype.calculateBodyWeightOnTargetBmi = function (target_bmi) {
        if (target_bmi && this.getValue('body_height')) {
            var height_m = this.getValue('body_height') / 100;
            var targetWeight = Math.round(target_bmi * (Math.pow(height_m, 2)));
            this.updateValue('target_body_weight', targetWeight);
        }
    };
    /**
     * Calculate the waist-hip ratio
     * @param waist_cm
     * @param hip_cm
     */
    SchemaModuleBariatric.prototype.calculateWaistHipRatio = function () {
        // Read via getValue (not the visibility-checked listenValue args): in imperial mode
        // the cm fields are hidden but kept in sync from the inch fields, so the ratio stays
        // correct when the user edits waist/hip in either unit mode.
        var waist_cm = this.getValue('waist_circumference');
        var hip_cm = this.getValue('hip_circumference');
        if (waist_cm && hip_cm) {
            this.updateValue('waist_hip_ratio', parseFloat((waist_cm / hip_cm).toFixed(2)));
        }
    };
    /**
     * Mirror the computed Excess Weight (kg) into its imperial (lbs) display field.
     */
    SchemaModuleBariatric.prototype.fieldHandlerExcessWeightImperial = function () {
        var excess_kg = this.getValue('excess_weight');
        if (excess_kg !== null && excess_kg !== undefined) {
            this.updateValue('excess_weight_imperial', Math.round(excess_kg * LBS_PER_KG * 10) / 10);
        }
        else {
            this.updateValue('excess_weight_imperial', null);
        }
    };
    /**
     * Convert a value between a metric/imperial field pair, keeping the two in sync.
     * Debounced to handle rapid typing and guarded with a per-pair flag to avoid feedback
     * loops. Runs only in the relevant unit mode, so editing the visible field updates the
     * hidden counterpart without the reverse handler firing back.
     *
     * @param value             New value of the source (listened) field
     * @param toField           Destination field to update
     * @param pairKey           Shared key identifying the metric/imperial pair
     * @param factor            Multiplier converting source units to destination units
     * @param activeInMetricMode Whether this direction runs in metric mode (true) or imperial mode (false)
     */
    SchemaModuleBariatric.prototype.convertUnit = function (value, toField, pairKey, factor, activeInMetricMode) {
        var _this = this;
        if (value === undefined || value === null || this._converting[pairKey]) {
            return;
        }
        // Only the direction matching the active unit mode should run.
        if (!!this.getValue('is_metric') !== activeInMetricMode) {
            return;
        }
        var timeoutKey = pairKey + ":" + toField;
        if (this._conversionTimeout[timeoutKey]) {
            clearTimeout(this._conversionTimeout[timeoutKey]);
        }
        this._conversionTimeout[timeoutKey] = setTimeout(function () {
            _this._converting[pairKey] = true;
            if (value > 0) {
                var converted = Math.round(value * factor * 10) / 10; // Round to 1 decimal place
                if (_this.getValue(toField) !== converted) {
                    _this.updateValue(toField, converted);
                }
            }
            else if (_this.getValue(toField) !== null) {
                _this.updateValue(toField, null);
            }
            _this._converting[pairKey] = false;
        }, 300);
    };
    return SchemaModuleBariatric;
}(SchemaModuleGeneral));
export { SchemaModuleBariatric };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-bariatric.ts.pre-build-optimizer.js